import classNames from 'classnames';

export default function Shading({ className }: { className?: string }) {
  return (
    <div
      className={classNames('absolute top-0 left-0 w-full h-full', className)}
    ></div>
  );
}
